export const E_CUSTOMER = 'E-Customer';
export const DEALER = 'Dealer';
export const TEPS_DEALER = 'Teps Dealer';
export const TEPS_DEALER_CAP = 'TEPS Dealer';
export const CUSTOMER = 'Customer';
export const DEALER_CUSTOMER = 'Dealer Customer';
